import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDialog
} from "@angular/material";

import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { HolidayTypeEmptyComponent } from "../holiday-type-empty/holiday-type-empty.component";
import { CalendarService } from "src/app/services/http/business/calendar/calendar.service";

@Component({
  selector: 'app-holiday-type-list',
  templateUrl: './holiday-type-list.component.html',
  styleUrls: ['./holiday-type-list.component.css']
})
export class HolidayTypeListComponent implements OnInit {
  isOwner: boolean;
  companySelected: string;
  companyList: ICompany[];
  filter: any;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    "title",
    "function"
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  pageSize: number;
  pageIndex: number;
  constructor(
    private dialog: MatDialog,
    private cidService: CIDService,
    public translate: TranslateService,
    // private errorService: ErrorsService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private calendarService: CalendarService,
  ) {}

  ngOnInit() {
  //  this.checkOwner();
  this.dataSource.paginator = this.paginator;
      this.getCompanyList();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) 
        this.getCompanyList();
      
    });
  }
  

  getDefultList(params): void {
    this.companySelected = params;
    this.cidService.setCID(params);
    this.refresh();
  }

  filterInComoany(event): void {
   
    this.getDefultList(event.value);
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
      this.getDefultList(this.companyList[0].CompanyEncryptId);
    });
  }
  refresh() {
    this.calendarService.holidayTypeList().subscribe(res => {
      this.dataSource = new MatTableDataSource(res.DataList);
    });
  }

  add() {
    this.dialog
      .open(HolidayTypeEmptyComponent, {
        width: "300px",
        data: {
          id:0,
          companyId:this.companySelected
        },
      })
      .afterClosed()
      .subscribe(
        () => {
          this.getCompanyList();
        },
    
      );
  }

  edit(data:any) {
    this.dialog
      .open(HolidayTypeEmptyComponent, {
        width: "300px",
        data: {
          id:data.Id,
          companyId:this.companySelected,
          Title:data.Title
        },
      })
      .afterClosed()
      .subscribe(
        () => {
          this.getCompanyList();
        },
      
      );
  }

  // delete(data: ITermInfo) {
  //   this.term = data;
  //   let confirm: IConfirm = {
  //     accept: true,
  //     message: this.translate.get("confirm.delete", {
  //       name: this.translate.get("label.term") + " " + data.Title
  //     }),
  //     alert:null,
  //     yesLabel: this.translate.get("label.yes"),
  //     noLabel: this.translate.get("label.no")
  //   };

  //   const dialogRef = this.dialog.open(ConfirmComponent, {
  //     width: "250px",
  //     data: confirm
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       this.termInfoService.delete(this.term).subscribe(
  //         () => {
  //           this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
  //         },
  //         err => {
  //           this.errorService.recordHasBennUsed(err);
  //         }
  //       );
  //     }
  //   });
  // }

  // ngOnDestroy() {
  //   if (this.isOwner) this.cidService.setCID("");
  // }
}
